/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Verify_Email_Page_DescriptionInputs */

const en_common_sign_verify_email_page_description = /** @type {(inputs: Common_Sign_Verify_Email_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To continue, click the link sent to`)
};

const zh_common_sign_verify_email_page_description = /** @type {(inputs: Common_Sign_Verify_Email_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续操作前，请点击发送到以下邮箱的验证链接：`)
};

/**
* | output |
* | --- |
* | "To continue, click the link sent to" |
*
* @param {Common_Sign_Verify_Email_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_verify_email_page_description = /** @type {((inputs?: Common_Sign_Verify_Email_Page_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Verify_Email_Page_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_verify_email_page_description(inputs)
	return zh_common_sign_verify_email_page_description(inputs)
});
export { common_sign_verify_email_page_description as "common.sign.verify_email_page_description" }